<template>
	<div class="service-locations-signature-card-edit">
		<!-- Repair Order Invoice Section -->
		<SectionContainer>
			<template #left>
				<h4>Repair Order Invoice</h4>
			</template>
			<template #content>
				<DraggableList
					title="Methods"
					subHeading="Drag & drop to order by preferred method."
				>
					<DraggableListItem
						v-for="(item, index) in localData.captureMethods"
						:key="index"
					>
						<template #content>
							<div>
								<Checkbox
									v-model="item.active"
									:labelText="item.name"
								/>
							</div>
						</template>
					</DraggableListItem>
				</DraggableList>
				<div>
					<h4>Capture Message</h4>
					<p>
						{{ localData.captureMessage }}
					</p>
				</div>
			</template>
		</SectionContainer>
		<SectionContainer>
			<template #left>
				<h4>Work Order Authorization</h4>
			</template>
			<template #content>
				<DraggableList
					title="Methods"
					subHeading="Drag & drop to order by preferred method."
				>
					<DraggableListItem
						v-for="(item, index) in localData.captureMethods"
						:key="index"
					>
						<template #content>
							<div>
								<Checkbox
									v-model="item.active"
									:labelText="item.name"
								/>
							</div>
						</template>
					</DraggableListItem>
				</DraggableList>
				<div>
					<h4>Capture Message</h4>
					<p>
						{{ localData.captureMessage }}
					</p>
				</div>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import DraggableList from '@/components/shells/draggable-list/draggable-list';
import DraggableListItem from '@/components/shells/draggable-list/draggable-list-item';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
import _ from 'lodash';

export default {
	name: 'PartsLocationsSignatureCardEdit',
	components: {
		SectionContainer,
		Checkbox,
		DraggableList,
		DraggableListItem
	},
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value)
		};
	},
	created() {
		// console.log('localData', this.localData);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.service-locations-signature-card-edit {
	@include card;

	&__item {
		display: block;
	}
}
</style>
